import React, { useMemo } from 'react'
import Dropdown from 'core/elements/dropdown'
import withProgress from 'core/components/progress/withProgress'
import useListAction from 'core/hooks/useListAction'
import { listResmgrHosts } from '../actions'
import { resmgrHostsSelector } from '../selectors'
import useSelectorWithParams from 'core/hooks/useSelectorWithParams'
import GlobalDropdownWithSearch from 'core/elements/dropdown/GlobalDropdownWithSearch'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

interface HostPicklistProps {
  disabled?: boolean
  name?: string
  label?: string
  includeNoneOption?: boolean
  includeAllOption?: boolean
  compact?: boolean
  onChange: (value: string) => void
  value: string
  width?: number
  align?: 'left' | 'right'
  [key: string]: any
}

export default function HostPicklist({
  disabled = false,
  name = 'host',
  label = 'Host',
  includeNoneOption = false,
  includeAllOption = false,
  compact = true,
  onChange,
  value,
  width = 180,
  align = 'right',
  ...rest
}: HostPicklistProps) {
  const { loading } = useListAction(listResmgrHosts)
  const hosts = useSelectorWithParams(resmgrHostsSelector, {} as any)

  const items = useMemo(() => {
    const hostOptions = hosts.map((host) => ({
      label: host.name,
      value: host.id,
    }))

    const result = []
    if (includeAllOption) {
      result.push({ label: 'All', value: 'all' })
    }
    if (includeNoneOption) {
      result.push({ label: '-- None --', value: '' })
    }
    return [...result, ...hostOptions]
  }, [hosts, includeNoneOption, includeAllOption])

  return compact ? (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={items}
    />
  ) : (
    <GlobalDropdownWithSearch
      label={label}
      items={items}
      loading={loading}
      onChange={(item) => onChange(item.value)}
      value={value}
      showLabelOnTop
      align={align}
      disabled={disabled}
      width={width}
    />
  )
}
